import { render, staticRenderFns } from "./ModalPayByCheck.vue?vue&type=template&id=604f0159&scoped=true&"
import script from "./ModalPayByCheck.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ModalPayByCheck.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ModalPayByCheck.vue?vue&type=style&index=0&id=604f0159&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604f0159",
  null
  
)

export default component.exports